// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"541d8c5c","453":"3f56b3d8","908":"94c803d0"}[chunkId] + ".chunk.js";
};